
import React, { useState } from 'react';
import { Icon } from './Icon';
import { APP_SETTINGS } from '../constants';

interface OrderModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedPackage: string;
  contactNumber: string; // Menambahkan prop contactNumber
}

export const OrderModal: React.FC<OrderModalProps> = ({ isOpen, onClose, selectedPackage, contactNumber }) => {
  const [formData, setFormData] = useState({
    name: '',
    agency: '',
    phone: '',
    message: ''
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Format pesan untuk WhatsApp
    const text = `Halo Admin *${APP_SETTINGS.brandName}*, saya tertarik melakukan pemesanan.%0A%0A` +
                 `📦 *Paket Dipilih:* ${selectedPackage}%0A` +
                 `👤 *Nama:* ${formData.name}%0A` +
                 `🏢 *Instansi/Bisnis:* ${formData.agency}%0A` +
                 `📝 *Catatan Tambahan:* ${formData.message || '-'}`;

    // Redirect ke WhatsApp menggunakan contactNumber yang dinamis dari admin panel
    // Fallback ke constant jika contactNumber kosong (safety check)
    const targetNumber = contactNumber || APP_SETTINGS.contactWhatsapp;
    const waUrl = `https://wa.me/${targetNumber}?text=${text}`;
    window.open(waUrl, '_blank');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[120] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-[#111827] w-full max-w-lg border border-white/10 rounded-3xl overflow-hidden shadow-2xl flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="p-6 border-b border-white/10 flex justify-between items-center bg-[#1f2937]">
          <div>
            <h3 className="text-xl font-bold text-white">Form Pemesanan</h3>
            <p className="text-xs text-purple-400 font-bold uppercase tracking-widest mt-1">
               {selectedPackage}
            </p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full text-white transition-colors">
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Nama Lengkap</label>
              <div className="relative">
                <div className="absolute left-4 top-3.5 text-slate-500"><Icon name="Users" size={18} /></div>
                <input 
                  required
                  className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-3 text-white outline-none focus:border-purple-500 transition-all placeholder:text-slate-600"
                  placeholder="Nama Anda"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Instansi / Sekolah / Bisnis</label>
              <div className="relative">
                <div className="absolute left-4 top-3.5 text-slate-500"><Icon name="Building" size={18} /></div> {/* Icon Building blm ada di map, kita pakai Layout dulu atau tambah nanti, sementara pakai Layout */}
                <input 
                  required
                  className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-3 text-white outline-none focus:border-purple-500 transition-all placeholder:text-slate-600"
                  placeholder="Nama Bisnis atau Instansi"
                  value={formData.agency}
                  onChange={(e) => setFormData({...formData, agency: e.target.value})}
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Nomor WhatsApp</label>
              <div className="relative">
                <div className="absolute left-4 top-3.5 text-slate-500"><Icon name="Smartphone" size={18} /></div>
                <input 
                  required
                  type="tel"
                  className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-3 text-white outline-none focus:border-purple-500 transition-all placeholder:text-slate-600"
                  placeholder="0812..."
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">Pesan / Kebutuhan Khusus</label>
              <textarea 
                className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-purple-500 transition-all h-24 resize-none placeholder:text-slate-600"
                placeholder="Ceritakan sedikit tentang kebutuhan website/aplikasi Anda..."
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
              />
            </div>

            <button 
              type="submit"
              className="w-full py-4 bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 rounded-xl font-bold text-white shadow-xl shadow-green-500/20 transition-all flex items-center justify-center gap-2 mt-4"
            >
              Lanjut ke WhatsApp <Icon name="MessageSquare" size={20} />
            </button>
            
            <p className="text-center text-[10px] text-slate-500">
              Data Anda aman. Kami akan mengarahkan Anda ke chat WhatsApp resmi kami untuk konfirmasi detail.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};
